import BookPage from "./book";

export default BookPage;